import "./influencer-discovery.scss";
import React, { useEffect, useCallback, useState } from "react";
import api from "api";
import moment, { Moment } from "moment";
import { actions } from "redux/reducers";
import { ClipType, InfluencerDiscoveryType } from "types";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

function InfluencerDiscovery({
    projectId,
    dateFrom,
    dateTo,
    streamIds,
    topAuthor,
}: {
    projectId: number;
    dateFrom: Moment;
    dateTo: Moment;
    streamIds: number[];
    topAuthor: { authorId: string; authorName: string; streamId: number } | null;
}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [influencers, setInfluencers] = useState<InfluencerDiscoveryType[]>([]);
    const [menuOpen, setMenuOpen] = useState<string>("");

    function onlyUnique(value: any, index: any, self: any) {
        return self.indexOf(value) === index;
    }

    const getInfluencers = useCallback(async () => {
        const data: InfluencerDiscoveryType[] = await api.influencerDiscovery.getAll(projectId);
        if (data.length) {
            setInfluencers(data.filter((x) => streamIds.includes(x.StreamId)));
        }
    }, [projectId, streamIds]);

    const getStream = useCallback((streamId) => {
        switch (streamId) {
            case 7:
                return "x-twitter";
            case 8:
                return "facebook";
            case 9:
                return "instagram";
            case 10:
                return "youtube";
            case 11:
                return "linkedin";
        }
    }, []);

    const openMenu = useCallback((id: string, e: any) => {
        e.stopPropagation();
        setMenuOpen(id);
    }, []);

    const viewPosts = async (authorId: string, e: any) => {
        e.stopPropagation();
        setMenuOpen("");
        dispatch(
            actions.clipTray.set({
                loading: true,
                clips: [],
                open: true,
            })
        );
        const clips: ClipType[] = await api.clip.getAll(projectId, dateFrom, dateTo, streamIds.join(","));
        dispatch(
            actions.clipTray.set({
                loading: false,
                clips: clips.filter((x) => x.AuthorId === authorId),
                open: true,
            })
        );
    };

    const viewInfluencer = (authorId: number) => {
        history.push(`/client/${params.clientId}/project/${params.projectId}/influencer-comparison?ids=${authorId}&datefrom=${dateFrom.format("YYYY-MM-DD")}&dateto=${dateTo.format("YYYY-MM-DD")}&streams=${streamIds}`);
    };

    const remove = async (id: number) => {
        await api.influencerDiscovery.remove(id);
        setInfluencers((curr) => curr.filter((x) => x.Id !== id));
    };

    useEffect(() => {
        if (topAuthor) {
            getInfluencers();
        }
    }, [topAuthor, getInfluencers]);

    useEffect(() => {
        function handleClick() {
            setMenuOpen("");
        }
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);

    useEffect(() => {
        getInfluencers();
    }, [getInfluencers]);

    return (
        <div className="influencer-discovery">
            <div className="top">
                <p>Influencer Discovery</p>
            </div>
            <div className="body">
                <div className="controls">
                    <i className="fal fa-clock"></i>
                </div>
                <div className="influencers">
                    {influencers.map((x, i) => {
                        return (
                            <div className={`influencer ${menuOpen === x.AuthorId ? "open" : ""}`} key={i}>
                                <i className={`fab fa-${getStream(x.StreamId)}`}></i>
                                <span className="influencer-name" onClick={(e) => openMenu(x.AuthorId, e)}>
                                    {x.AuthorName} <i className="fas fa-caret-down"></i>
                                </span>
                                <span className="influencer-days">{moment(x.DateCreated).add(1, "y").diff(moment(), "days")} days</span>
                                <div className={`influencer-menu`}>
                                    <p className="influencer-name">{x.AuthorName}</p>
                                    <p onClick={(e) => viewPosts(x.AuthorId, e)}>View Posts</p>
                                    <p onClick={() => viewInfluencer(x.Id)}>View Influencer</p>
                                    <p onClick={() => remove(x.Id)}>Remove Influencer</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default InfluencerDiscovery;
